import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./DataEntryPage.css";

const DataEntryPage = ({ triggerUpdate }) => {
  const [excelSheets, setExcelSheets] = useState([]);
  const [selectedSheet, setSelectedSheet] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [importantDate, setImportantDate] = useState("");
  const [sessionId, setSessionId] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Beim Laden der Seite Session-ID aus LocalStorage holen
  useEffect(() => {
    const session = localStorage.getItem("sessionId");
    if (!session) {
      alert("Keine aktive Sitzung gefunden. Bitte starten Sie eine neue Sitzung.");
      navigate("/");
    } else {
      setSessionId(session);
    }
  }, [navigate]);

  // Excel-Datei hochladen & Arbeitsblätter abrufen
  const handleExcelImport = async (event) => {
    const file = event.target.files[0];
    if (!file) {
      alert("Bitte wählen Sie eine Excel-Datei aus.");
      return;
    }

    setLoading(true); // ⏳ Ladeanzeige aktivieren

    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await fetch("https://app.sijelly.com/api/excel/upload", {
        method: "POST",
        body: formData,
        headers: { "Session-ID": sessionId },
      });

      if (!response.ok) {
        const errorData = await response.json();
        alert(errorData.detail || "Fehler beim Hochladen der Excel-Datei.");
        return;
      }

      const data = await response.json();
      setExcelSheets(data.sheets || []);

      // Automatische Vorauswahl eines Sheets, das "Daten" enthält
      const defaultSheet = data.sheets.find(sheet => sheet.toLowerCase().includes("daten")) || "";
      setSelectedSheet(defaultSheet);
      
    } catch (error) {
      console.error("Fehler beim Laden der Excel-Datei:", error);
      alert("Fehler beim Laden der Excel-Datei.");
    } finally {
      setLoading(false); // ✅ Ladeanzeige deaktivieren
    }
  };

  // Arbeitsblattdaten abrufen
  const handleSheetSelection = async () => {
    if (!selectedSheet) {
      alert("Bitte wählen Sie ein Arbeitsblatt aus.");
      return;
    }
  
    setLoading(true); // Ladeanzeige aktivieren
  
    try {
      const formData = new FormData();
      formData.append("sheet", selectedSheet);
  
      const response = await fetch("https://app.sijelly.com/api/excel/get_sheet_data", {
        method: "POST",
        body: formData,
        headers: { "Session-ID": sessionId },
      });
  
      const data = await response.json();
  
      if (response.ok) {
        setAccountNumber(data.accountNumber);
        setImportantDate(data.newestDate);
  
        if (triggerUpdate) {
          console.log("🔄 triggerUpdate wird ausgelöst nach Arbeitsblatt-Auswahl!");
          triggerUpdate(); // ✅ Zeigt MappingPage an
        }
        
      } else {
        alert(data.detail || "Fehler beim Abrufen der Arbeitsblattdaten.");
      }
    } catch (error) {
      console.error("Fehler beim Abrufen der Arbeitsblattdaten:", error);
      alert("Fehler beim Abrufen der Arbeitsblattdaten.");
    } finally {
      setLoading(false); // Ladeanzeige deaktivieren
    }
  };

  return (
    <div className="data-entry">
      {/* Lade-Pop-up */}
      {loading && (
        <div className="loading-overlay">
          <div className="loading-box">
            <div className="loading-spinner"></div>
            <p>Daten werden geladen...</p>
          </div>
        </div>
      )}

      <div className="content-container">
        {/* Linke Seite (Buttons & Dropdown) */}
        <div className="left-container2">
          <div className="button-container">
            <label className="styled-button">
              <i className="icon-excel"></i> Excel-Datei importieren
              <input type="file" onChange={handleExcelImport} accept=".xlsx" className="hidden-input" />
            </label>

            {/* Dropdown für Arbeitsblätter (nur anzeigen, wenn Excel geladen wurde) */}
            {excelSheets.length > 0 && (
              <select
                value={selectedSheet}
                onChange={(e) => setSelectedSheet(e.target.value)}
                className="sheet-dropdown"
              >
                {excelSheets.map((sheet, index) => (
                  <option key={index} value={sheet}>{sheet}</option>
                ))}
              </select>
            )}

            {/* Daten abrufen Button nur anzeigen, wenn eine Datei geladen wurde */}
            {excelSheets.length > 0 && (
              <button className="select-button" onClick={handleSheetSelection}>
                Daten abrufen
              </button>
            )}
          </div>
        </div>

        {/* Trennlinie */}
        <div className="divider"></div>

        {/* Rechte Seite (Ergebnisse) */}
        <div className="right-container">
          {(accountNumber || importantDate) && (
            <div className="sheet-results">
              <h2>Ergebnisse aus dem Arbeitsblatt</h2>
              <p><strong>Auftragskonto:</strong> {accountNumber || "Nicht gefunden"}</p>
              <p><strong>Wichtiges Datum:</strong> {importantDate || "Kein Datum gefunden"}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DataEntryPage;